/**
 * User nutrition object represents authentication-related API endpoints and their methods.
 */
const UserNutrition = {
  /**
   * Endpoint for admin UserNutrition list.
   * @memberof UserNutrition
   * @type {object}
   * @property {string} url - The URL for admin login.
   * @property {string} method - The HTTP method for admin login (POST).
   */
  getUserNutritionList: {
    url: "/admin/user-nutrition-log",
    method: "GET",
  },
  getUserNutritionDetails: (id) => ({
    url: `/admin/user-nutrition-log/${id}`,
    method: "GET",
  }),
};

// Export the User Nutrition object for use in other modules
export default UserNutrition;
